/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlingUnitType } from './HandlingUnitType';
import {
    HandlingUnitTypeFromJSON,
    HandlingUnitTypeFromJSONTyped,
    HandlingUnitTypeToJSON,
    HandlingUnitTypeToJSONTyped,
} from './HandlingUnitType';
import type { TemperatureHandling } from './TemperatureHandling';
import {
    TemperatureHandlingFromJSON,
    TemperatureHandlingFromJSONTyped,
    TemperatureHandlingToJSON,
    TemperatureHandlingToJSONTyped,
} from './TemperatureHandling';

/**
 * A saved commodity with all fields
 * @export
 * @interface SavedCommodity
 */
export interface SavedCommodity {
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    savedCommodityId: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    nmfcItemNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    description: string;
    /**
     * 
     * @type {HandlingUnitType}
     * @memberof SavedCommodity
     */
    handlingUnitType: HandlingUnitType;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousUnNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousClassification?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SavedCommodity
     */
    isDangerous: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SavedCommodity
     */
    isStackable: boolean;
    /**
     * 
     * @type {TemperatureHandling}
     * @memberof SavedCommodity
     */
    temperatureHandling: TemperatureHandling;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousPackingGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousProperShippingName?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousTechnicalName?: string;
    /**
     * 
     * @type {number}
     * @memberof SavedCommodity
     */
    dangerousNumberPackages?: number;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    dangerousPackagingType?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedCommodity
     */
    skuIdentifier?: string;
    /**
     * Length in inches. `lengthInches` greater than 600 cannot be combined with `widthInches` greater than 96 (flatbed envelope).
     * @type {number}
     * @memberof SavedCommodity
     */
    lengthInches?: number;
    /**
     * Width in inches. `widthInches` greater than 96 cannot be combined with `lengthInches` greater than 600 (flatbed envelope).
     * @type {number}
     * @memberof SavedCommodity
     */
    widthInches?: number;
    /**
     * Height in inches.
     * @type {number}
     * @memberof SavedCommodity
     */
    heightInches?: number;
    /**
     * What created this commodity. Read-only and stamped by the server — a value sent on a create is ignored, because provenance a caller can assert is provenance nobody can trust. Written once and never overwritten, so editing a commodity does not change it. Absent means nobody could establish where the row came from, which is not the same as "created by hand": treat absent as unknown. A Shopify sync fills in an absent value for the SKUs its store returns. Lets a merchant find the rows an integration made, which is how the ones a Shopify sync left without dimensions become findable at all.
     * @type {string}
     * @memberof SavedCommodity
     */
    readonly createdSource?: SavedCommodityCreatedSourceEnum;
    /**
     * Name of the person who created this commodity in the FreightSimple Dashboard, as it was at the time. Read-only and stamped by the server; never overwritten by an edit. Absent for commodities an integration, an upload or the API created, and for Dashboard commodities created before this field existed.
     * @type {string}
     * @memberof SavedCommodity
     */
    readonly createdByName?: string;
}


/**
 * @export
 */
export const SavedCommodityCreatedSourceEnum = {
    ShopifySync: 'shopify_sync',
    Dashboard: 'dashboard',
    PublicApi: 'public_api',
    BulkUpload: 'bulk_upload'
} as const;
export type SavedCommodityCreatedSourceEnum = typeof SavedCommodityCreatedSourceEnum[keyof typeof SavedCommodityCreatedSourceEnum];


/**
 * Check if a given object implements the SavedCommodity interface.
 */
export function instanceOfSavedCommodity(value: object): value is SavedCommodity {
    if (!('savedCommodityId' in value) || value['savedCommodityId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('handlingUnitType' in value) || value['handlingUnitType'] === undefined) return false;
    if (!('isDangerous' in value) || value['isDangerous'] === undefined) return false;
    if (!('isStackable' in value) || value['isStackable'] === undefined) return false;
    if (!('temperatureHandling' in value) || value['temperatureHandling'] === undefined) return false;
    return true;
}

export function SavedCommodityFromJSON(json: any): SavedCommodity {
    return SavedCommodityFromJSONTyped(json, false);
}

export function SavedCommodityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedCommodity {
    if (json == null) {
        return json;
    }
    return {
        
        'savedCommodityId': json['savedCommodityId'],
        'nmfcItemNumber': json['nmfcItemNumber'] == null ? undefined : json['nmfcItemNumber'],
        'description': json['description'],
        'handlingUnitType': HandlingUnitTypeFromJSON(json['handlingUnitType']),
        'dangerousUnNumber': json['dangerousUnNumber'] == null ? undefined : json['dangerousUnNumber'],
        'dangerousClassification': json['dangerousClassification'] == null ? undefined : json['dangerousClassification'],
        'isDangerous': json['isDangerous'],
        'isStackable': json['isStackable'],
        'temperatureHandling': TemperatureHandlingFromJSON(json['temperatureHandling']),
        'dangerousPackingGroup': json['dangerousPackingGroup'] == null ? undefined : json['dangerousPackingGroup'],
        'dangerousProperShippingName': json['dangerousProperShippingName'] == null ? undefined : json['dangerousProperShippingName'],
        'dangerousTechnicalName': json['dangerousTechnicalName'] == null ? undefined : json['dangerousTechnicalName'],
        'dangerousNumberPackages': json['dangerousNumberPackages'] == null ? undefined : json['dangerousNumberPackages'],
        'dangerousPackagingType': json['dangerousPackagingType'] == null ? undefined : json['dangerousPackagingType'],
        'skuIdentifier': json['skuIdentifier'] == null ? undefined : json['skuIdentifier'],
        'lengthInches': json['lengthInches'] == null ? undefined : json['lengthInches'],
        'widthInches': json['widthInches'] == null ? undefined : json['widthInches'],
        'heightInches': json['heightInches'] == null ? undefined : json['heightInches'],
        'createdSource': json['createdSource'] == null ? undefined : json['createdSource'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
    };
}

  export function SavedCommodityToJSON(json: any): SavedCommodity {
      return SavedCommodityToJSONTyped(json, false);
  }

  export function SavedCommodityToJSONTyped(value?: Omit<SavedCommodity, 'createdSource'|'createdByName'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'savedCommodityId': value['savedCommodityId'],
        'nmfcItemNumber': value['nmfcItemNumber'],
        'description': value['description'],
        'handlingUnitType': HandlingUnitTypeToJSON(value['handlingUnitType']),
        'dangerousUnNumber': value['dangerousUnNumber'],
        'dangerousClassification': value['dangerousClassification'],
        'isDangerous': value['isDangerous'],
        'isStackable': value['isStackable'],
        'temperatureHandling': TemperatureHandlingToJSON(value['temperatureHandling']),
        'dangerousPackingGroup': value['dangerousPackingGroup'],
        'dangerousProperShippingName': value['dangerousProperShippingName'],
        'dangerousTechnicalName': value['dangerousTechnicalName'],
        'dangerousNumberPackages': value['dangerousNumberPackages'],
        'dangerousPackagingType': value['dangerousPackagingType'],
        'skuIdentifier': value['skuIdentifier'],
        'lengthInches': value['lengthInches'],
        'widthInches': value['widthInches'],
        'heightInches': value['heightInches'],
    };
}

